import React from 'react';
import { BrowserRouter as Router, Route, Routes, Outlet, Navigate } from 'react-router-dom';
// import './App.css'; // Removed default App.css import - styles handled by index.css/Tailwind
import NavBar from './components/NavBar';
import Footer from './components/Footer';
import LandingPage from './pages/landing/LandingPage';
import LoginPage from './pages/auth/LoginPage';
import RegisterPage from './pages/auth/RegisterPage';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import { AppLayout } from './components/AppLayout';
// Import the actual pages
import DashboardPage from './pages/goal_planner/DashboardPage';
// import GoalPlannerPage from './pages/goal_planner/GoalPlannerPage'; // Remove old import
// Import the new pages
import TasksPage from './pages/tasks/TasksPage';
import GoalsPage from './pages/goals/GoalsPage';
import CategoriesPage from './pages/categories/CategoriesPage';
import HabitTrackerPage from './pages/habits/HabitTrackerPage';
import { Toaster } from "./components/ui/toaster";

// Placeholder pages for authenticated routes - replace with actual imports later
// const TasksPage = () => <div className="p-4">Daily Tasks Content Placeholder</div>; // Placeholder - Remove
// const GoalsPage = () => <div className="p-4">Goals Content Placeholder</div>; // Placeholder - Remove
// const CategoriesPage = () => <div className="p-4">Categories Content Placeholder</div>; // Placeholder - Remove

// Placeholder pages for authenticated routes
// const DashboardPage = () => <div>Dashboard Content Placeholder</div>;
// const GoalsPage = () => <div>Goals Content Placeholder</div>;
// const TasksPage = () => <div>Tasks Content Placeholder</div>;
// const CategoriesPage = () => <div>Categories Content Placeholder</div>;
// const SettingsPage = () => <div>Settings Content Placeholder</div>;

function App() {
  return (
    <Router>
      <AuthProvider> { /* Wrap everything inside AuthProvider */}
        {/* Add back NavBar/Footer wrapper */}
        <div className="flex flex-col min-h-screen" data-testid="app-container">
          <NavBar /> {/* <-- Uncomment NavBar */}
          <main className="flex-grow"> {/* Removed container/padding here, handled by pages/layout */}
            <Routes>
              {/* Public Routes */}
              <Route path="/" element={<LandingPage />} /> {/* Use LandingPage for root */}
              <Route path="/login" element={<LoginPage />} /> {/* Add Login Route */}
              <Route path="/register" element={<RegisterPage />} /> {/* Add Register Route */}

              {/* Authenticated Routes */}
              <Route
                path="/" // Use root path for authenticated app section
                element={
                  <ProtectedRoute>
                    <AppLayout>
                      <Outlet /> { /* Nested routes render here */ }
                    </AppLayout>
                  </ProtectedRoute>
                }
              >
                {/* Nested routes relative to the parent path */}
                <Route path="dashboard" element={<DashboardPage />} /> { /* Matches /dashboard */}
                {/* Redirect old route */}
                <Route path="goal-planner" element={<Navigate to="/dashboard" replace />} />
                {/* Add new routes */}
                <Route path="tasks" element={<TasksPage />} /> { /* Matches /tasks */}
                <Route path="goals" element={<GoalsPage />} /> { /* Matches /goals */}
                <Route path="categories" element={<CategoriesPage />} /> { /* Matches /categories */}
                <Route path="habits" element={<HabitTrackerPage />} /> {/* Add Habit Tracker Route */}
                {/* Redirects and old routes */}
                <Route index element={<Navigate to="/dashboard" replace />} /> { /* Redirect root inside protected to dashboard */}
                {/* Remove old placeholders */}
                {/* <Route index element={<DashboardPage />} /> { /* Matches /dashboard */}
                {/* <Route path="/dashboard" element={<DashboardPage />} /> { /* Explicit path */}
                {/* <Route path="goals" element={<GoalsPage />} /> { /* Matches /dashboard/goals - adjust AppLayout links if needed */}
                {/* <Route path="tasks" element={<TasksPage />} /> { /* Matches /dashboard/tasks */}
                {/* <Route path="categories" element={<CategoriesPage />} /> { /* Matches /dashboard/categories */}
                {/* <Route path="settings" element={<SettingsPage />} /> { /* Matches /dashboard/settings */}
                {/* Add other nested authenticated routes here */}
              </Route>

              {/* Optional: Catch-all or 404 route */}
              {/* <Route path="*" element={<NotFoundPage />} /> */}
            </Routes>
          </main>
          <Footer /> {/* <-- Uncomment Footer */}
          <Toaster /> { /* Add Toaster here */}
        </div>
      </AuthProvider>
    </Router>
  );
}

export default App;
